import {post, get, postBody} from "./http";

export const api = {
    baseUrl: process.env.VUE_APP_BASEURL_DEV,
    params: {
        userId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).userId : '',
        appType: 2,
        phoneSystem: "iOS"
    },

    //获取排行榜列表
    getRankUsers: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/rank/userRank`, param);
    },

    //任务列表
    getBoxTaskList: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/boxTask/boxTaskList`, param);
    },
    //开宝箱次数，与未开始的任务
    getOpenBoxNumAndUnCompleteTaskList: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/boxTask/getOpenBoxNumAndUnCompleteTaskList`,
            param
        );
    },
    //签到
    boxSign: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/boxTask/boxSign`, param);
    },
    //开宝箱
    openBox: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/boxPrize/openBoxPrize`, param);
    },
    //完成任务
    boxTaskComplete: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/boxTask/boxTaskComplete`, param);
    },
    //检测是否可开红包
    checkOpenRed: function (param = {}) {
        Object.assign(param, this.params);
        return postBody(this.baseAdUrl + `/red/getOpenRed`, param);
    },
    //红包群奖励
    adReward: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseAdUrl + `/red/reward`, param);
    },
    //我的奖品
    getMyBoxPrizeList: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/boxPrize/getMyBoxPrizeList`, param);
    },
    //获奖记录
    boxPrizeList: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/boxPrize/boxPrizeList`, param);
    },
    //获取广告配置
    getAdvertiseConfig: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/redGroup/getAdvertiseConfig`, param);
    },
    getAdvertiseConfigUrl: function () {
        return this.baseUrl + `/api/redGroup/getAdvertiseConfig`;
    },


    //获取挑战赛活动列表
    getChallengeActivityList: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/challengeActivity/getActivityList`,
            param
        );
    },
    //获取团长挑战赛统计数据
    getChallengeGetStatistics: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/challengeParticipant/getStatistics`,
            param
        );
    },
    //获取当前用户正在进行的挑战赛
    getCurrentOngoingChallenge: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/challengeParticipant/getCurrentOngoingChallenge`,
            param
        );
    },
    //挑战赛报名
    challengeApply: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/challengeParticipant/register`, param);
    },
    //放弃挑战
    giveUpChallenge: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/challengeParticipant/giveUpChallenge`,
            param
        );
    },
    //获取当前用户挑战赛参与记录列表
    getUserChallengeList: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/challengeParticipant/getUserChallengeList`,
            param
        );
    },
    //查询当前登录用户报名挑战赛团员信息
    getChallengeMembers: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/challengeParticipant/getChallengeMembers`,
            param
        );
    },

    getUserInfo: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/user/getUserInfo", param);
    },


    getFunctionList: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/function/getFunctionList", param);
    },


    juTuiKeList(param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + "/api/juTuiKe/list", param);
    },
    juTuiKeDetail(param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + "/api/juTuiKe/detail", param);
    },
    getListCoupon(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/meituanUnion/listCoupon", param);
    },
    // getCouponUrl(param = {}) {
    //     Object.assign(param, this.params);
    //     return post(this.baseUrl + "/api/meituanUnion/getCouponUrl", param);
    // },

//邀请好友详情页信息
    getUserInviteDetail: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/invite/getUserInviteDetail", param);
    },
    getInviteRecord: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/invite/getInviteRecord?size=${param.size}&current=${param.current}`, param);
    },
    getIncomeRecord: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/invite/getIncomeRecord?size=${param.size}&current=${param.current}`, param);
    },


    getAccountDetail: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/account/getAccountDetail?size=${param.size}&current=${param.current}&businessType=${param.businessType}`, param);
    },


    //常用问题列表
    questionCommon: function (param = {}) {
        Object.assign(param, this.params);
        return get(
            this.baseUrl +
            `/api/question/common?size=${param.size}&current=${param.current}`,
            param
        );
    },
    //我的反馈列表
    myQuestionList: function (param = {}) {
        Object.assign(param, this.params);
        return get(
            this.baseUrl +
            `/api/question/myQuestionList?size=${param.size}&current=${param.current}`,
            param
        );
    },
    //提交问题反馈
    submitQuestion: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/question/submit`, param);
    },
    //查看回复信息
    viewMsg: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/question/viewMsg`, param);
    },
    //阅读回复信息
    readMsg: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/question/readMsg`, param);
    },
    //常见问题详情
    getByIdCommon: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/question/getByIdCommon`, param);
    },


    getMsg: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/msg/userMsgPage`, param);
    },
    getMsgDetail: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/msg/userMsgDetail/${param.id}`);
    },
    getMsgNum: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/msg/countUnReadByUserId`);
    },

    updateMsgNum: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/msg/updateUnReadByUserMsgId/${param.id}`);
    },

    msgClearData: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/msg/updateUnReadByUserId`);
    },


    //检测支付宝绑定状态
    checkAliPayBind: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/pay/getCashBindStatus", param);
    },
    //绑定支付宝
    bindAliPay: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/pay/bindPayIOS", param);
    },
    //修改支付宝
    upDateAliPay: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/pay/updatePayIOS", param);
    },
    //支付宝提现
    payCash: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/cash/payCash", param);
    },
    //支付宝提现记录列表
    cashList: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl +
            `/api/cash/cashList?size=${param.size}&current=${param.current}`,
            param
        );
    },
    //支付宝提现记录详情
    cashDetails: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/cash/cashRecordDetail", param);
    },


    //获取微信提现绑定信息
    getWxCashBindInfo: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/wx/getWxCashBindInfo", param);
    },
    //修改
    updateWx: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/wx/updateWx", param);
    },
    //微信绑定-APP
    wxBind: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/wx/wxBind", param);
    },
    //微信提现-APP
    wxCash: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/cash/wxCash", param);
    },


    //信誉分列表
    queryUserBehavioralScoreList: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/behavioralscore/queryUserBehavioralScoreList?size=${param.size}&current=${param.current}`,
            param
        );
    },


    orderDetail(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + "/api/order/orderDetail", param);
    },


    //收支明细 金币记录
    goldList: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl +
            `/api/redGroup/goldList?size=${param.size}&current=${param.current}`,
            param
        );
    },
    //兑换金币
    exchangeGlod: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/redGroup/exchange`, param);
    },
    //美团返利优惠列表
    listCoupon: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/meituanUnion/listCoupon`, param);
    },
    //获取cps业务的推广链接
    getPromotionLink: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl +
            `/api/yunzhan/getPromotionLink?linkType=${param.linkType}&clickZone=${param.clickZone}`,
            param
        );
    },
    //获取商品推广链接
    getCouponUrl: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl +
            `/api/meituanUnion/getCouponUrl?linkType=${param.linkType}`,
            param
        );
    },
    //获取返利记录
    getRebateRecord: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl +
            `/api/yunzhan/getRebateRecord?current=${param.current}&size=${param.size}`,
            param
        );
    },
    //是否有可用的返利红包
    hasRebateRedEnvelope: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/redEnvelope/hasRebateRedEnvelope`, param);
    },

    //领取可用的返利红包
    receiveRebateRedEnvelope: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/redEnvelope/receiveRebateRedEnvelope`, param);
    },

    //获取挑战赛奖励人员列表
    getChallengeRewardList: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/challengeRewardRecord/getRewardList`,
            param
        );
    },

    //获取美团完单挑战活动列表
    getMeiTuanActivityList: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/meituanDailyActivity/getActivityList`,
            param
        );
    },
    //挑战赛(美团)报名
    challengeApplyMt: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/meituanDailyParticipant/register`, param);
    },
    //获取当前用户正在进行的美团完单活动
    getCurrentOngoingActivity: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/meituanDailyParticipant/getCurrentOngoingActivity`,
            param
        );
    },
    //放弃美团活动任务
    giveUpActivity: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/meituanDailyParticipant/giveUpActivity`,
            param
        );
    },
    //领取美团完单奖励
    claimReward: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/meituanDailyParticipant/claimReward`,
            param
        );
    },
    //获取返利金额记录
    getRebateAmountTotal: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/yunzhan/getRebateAmountTotal`, param);
    },
    //获取当前登录人的美团完单参与记录
    getMyParticipantRecord: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl + `/api/meituanDailyParticipant/getMyParticipantRecord`,
            param
        );
    },
    //获取累计人数和收益
    getCumulative: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/cumulative/getCumulative`, param);
    },
    //完成订单>1或首次提现完成
    orderFinishOrFirstCash: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/user/orderFinishOrFirstCash`, param);
    },
    //返现记录
    getAccountDetailReturn: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl +
            `/api/account/getAccountDetail?size=${param.size}&current=${param.current}&changeDescType=2&changeType=1`,
            param
        );
    },
    //邀请模块埋点
    levelInfo: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/user/levelInfo`, param);
    },

    //获取用户会员等级配置
    getLevelConfig: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/user/levelConfig`, param);
    },

    //熊猫空投首页信息接口
    getAirHomeInfo: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/airdropActivity/getInfo`, param);
    },
    //放入金竹接口
    addGoldBamboo: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/airdropActivity/addGoldBamboo`, param);
    },
    //获取每日任务列表
    getAirTaskConfigList: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/taskDailyReward/getConfigList`, param);
    },
    //金竹发放每日任务奖励
    airTasjSend: function (param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/taskDailyReward/sendReward`, param);
    },
    //空投奖励记录
    getAirRewardRecode: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl +
            `/api/airdropActivity/getDetailList?current=${param.current}&size=${param.size}`,
            param
        );
    },

    //金竹记录
    getGoldBambooList: function (param = {}) {
        Object.assign(param, this.params);
        return post(
            this.baseUrl +
            `/api/airdropActivity/getGoldBambooList?current=${param.current}&size=${param.size}`,
            param
        );
    },

    //是否首次提现
    isFirstWithdrawal: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/cash/isFirstWithdrawal`, param);
    },
    //熊猫餐厅主页信息
    gameMainPage: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/gameMainPage`, param);
    },
    //招募员工
    buyEmployees: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/buyEmployees`, param);
    },

    //一键领取
    claimAll: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/claimAll`, param);
    },
    //查询员工列表
    employees: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/employees`, param);
    },
    //查询当前等级
    getCurrentLevel: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/getCurrentLevel`, param);
    },

    //能量记录
    energyList: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/energyList`, param);
    },
    //是否开启创业 false：已经开启创业  true：未开启创业
    startBusinessBtnSwitch: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/startBusinessBtnSwitch`, param);
    },
    //开启创业
    startBusiness: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/startBusiness`, param);
    },

    //每日任务
    taskCompleteStatus: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/taskCompleteStatus`, param);
    },

    //升级餐厅
    levelUpRestaurant: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/levelUpRestaurant`, param);
    },

    //获取今日首个订单
    todayFirstOrder: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/panda/todayFirstOrder`, param);
    },

    //查询合伙人团队成员列表
    partnerMembers: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/partner/team/members`, param);
    },

    partnerInfo: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/partner/info`, param);
    },
    taskDisplay: function (param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/partner/task/display`, param);
    },
};
